'use client';

import { CompetitionHistory, Hero, LearnMore, Steps, TimeLine } from './_pageComponents';
import { PageLayout2, PageLoader } from '@/components';
import React, { useMemo, useState } from 'react';
import { CompetitionController } from '@/controllers';
import { ICompetitionListDTO } from '@/interfaces';

export const dynamic = 'force-dynamic';

const Competition = () => {
  const [limit, setLimit] = useState(50);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');

  const query = useMemo(() => {
    return {
      offset: currentPage + 1,
      limit,
      ...(searchQuery ? { search: searchQuery } : {}),
    };
  }, [currentPage, limit, searchQuery]);

  const { data, isLoading } = CompetitionController.useGetCompetitions(query);

  if (isLoading) {
    return <PageLoader loading={isLoading} title="while we fetch your data" />;
  }

  const competitionList = (data as ICompetitionListDTO)?.data?.competitions || [];

  return (
    <PageLayout2>
      <Hero competitionList={competitionList} />
      <TimeLine competitionList={competitionList} />
      <Steps competitionList={competitionList} />
      <LearnMore competitionList={competitionList} />
      <CompetitionHistory />
    </PageLayout2>
  );
};

export default Competition;

// 'use client';
// import { PageLayout2, PageLoader } from '@/components';
// import React, { useMemo, useState } from 'react';
// import { Hero, LearnMore, Steps, TimeLine } from './_pageComponents';
// import { CompetitionController } from '@/controllers';
// import { ICompetitionListDTO } from '@/interfaces';

// export const dynamic = 'force-dynamic';

// const Competition = () => {
//   const [limit, setLimit] = useState(50);
//   const [currentPage, setCurrentPage] = useState(0);
//   const [searchQuery, setSearchQuery] = useState('');

//   const query = useMemo(() => {
//     return {
//       offset: currentPage + 1,
//       limit,
//       ...(searchQuery ? { search: searchQuery } : {}),
//     };
//   }, [currentPage, limit, searchQuery]);

//   const { data, isLoading, isError } = CompetitionController.useGetCompetitions(query);

//   if (isLoading) {
//     return <div>Loading...</div>; // Add loading state or spinner
//   }

//   if (isError) {
//     return <div>Error loading competitions.</div>; // Handle error state
//   }

//   const competitionList = (data as ICompetitionListDTO)?.data?.competitions || [];

//   return (
//     <PageLayout2>
//       <Hero competitionList={competitionList} />
//       <TimeLine competitionList={competitionList} />
//       <Steps competitionList={competitionList} />
//       <LearnMore competitionList={competitionList} />
//     </PageLayout2>
//   );
// };

// export default Competition;
